import { render, staticRenderFns } from "./SingleImageMenu.vue?vue&type=template&id=db54f1e6&"
import script from "./SingleImageMenu.vue?vue&type=script&lang=js&"
export * from "./SingleImageMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports